export default __webpack_public_path__ + "static/media/Notice-of-AGM-2026.d4bb7c82.pdf";